import React from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import { Controller } from 'react-hook-form'

/**
 * Each ticket type's earned value beside the field that overrides it. `rows` is the campaign's
 * ticket types; `earnedFor` returns what one earns on its own.
 */
export const TicketOverrideTable = ({ control, rows, earnedFor }) => (
  <>
    <Typography variant='caption' color='text.secondary' display='block' sx={{ mb: 1 }}>
      Leave a value blank to keep the earned amount.
    </Typography>
    <TableContainer component={Paper} variant='outlined'>
      {/* Fixed, or the widths below are advisory and collapse to content width. */}
      <Table size='small' sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            <TableCell>Ticket</TableCell>
            <TableCell sx={{ width: 100 }}>Earned</TableCell>
            <TableCell sx={{ width: 100 }}>Override</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.label}</TableCell>
              <TableCell>{earnedFor(row.id)}</TableCell>
              <TableCell>
                <Controller
                  name={`ticketOverrides.${row.id}`}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      fullWidth
                      size='small'
                      variant='outlined'
                      type='number'
                      inputProps={{ min: 0 }}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)
